import React, { useState, useEffect, useRef } from 'react'
import './ManageBilling.css'
import BillingComponent from '../components/billing/BillingComponent'
import { GpModalShell, GpButton } from '../components/gp'

export default function NewCardModal(props) {
    const [loading, setLoading] = useState(false)
    const [buttonText, setButtonText] = useState('Save')
    const billingRef = useRef()

    useEffect(() => {
        let timer
        if (loading) {
            timer = setTimeout(() => {
                setButtonText('Authorizing…')
            }, 2200)
        } else {
            setButtonText('Save')
        }
        return () => {
            clearTimeout(timer)
        }
    }, [loading])

    const handleNewCard = async () => {
        setLoading(true)
        if (billingRef.current) {
            const success = await billingRef.current.handleSubmit()
            if (!success) {
                setLoading(false)
            }
        }
    }

    const creditCardAdded = () => {
        setTimeout(() => {
            props.reloadWallet()
            props.handleClose()
        }, 3000)
    }

    return (
        <GpModalShell
            open={props.open}
            onClose={props.handleClose}
            title="Add new card"
            width={580}
            footer={
                <>
                    <GpButton variant="ghost" onClick={props.handleClose} disabled={loading}>
                        Cancel
                    </GpButton>
                    <GpButton
                        variant="primary"
                        onClick={handleNewCard}
                        disabled={loading}
                        data-testid="cypress-billing-add-new-card-save-button"
                    >
                        {buttonText}
                    </GpButton>
                </>
            }
        >
            <div data-testid="cypress-billing-add-new-card-modal">
                <BillingComponent
                    buttonText="Save"
                    ref={billingRef}
                    setParentLoading={setLoading}
                    creditCardAdded={creditCardAdded}
                />
            </div>
        </GpModalShell>
    )
}
